import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Snackbar from "@material-ui/core/Snackbar";
import Fade from "@material-ui/core/Fade";
import { base_url } from "../../Api/Api";
import { Popup } from "../../Global/Popup";
import { Loader } from "../../Global/Loader";

import Header from "../../Global/Header";
import Answeritem from "./Answeritem";
import { Fragment } from "react";

const Exam = (props) => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({
    selectedAnswer: null, // answer selected
    paramsId: 0, // params number
    defaultChecked: {
      answer_ids: [],
      question_id: "",
    }, // checked input
    popupStatus: false, // toggle popup
    timerAnimation: false,
    time: Date.now(),
    timeOut: false,
    animationItems: false,
    animParamsId: 0,
    finished: false,
    examIdMain: 0,
    pervQueId: 0,
  });

  const [count, setCount] = useState(0);
  const [maxCount, setMaxCount] = useState(0);
  const [answers, setAnswers] = useState([]); // all answers selected set here
  const [temAnswer, setTemAnswer] = useState(null); // temprory answer
  const [details, setDetails] = useState({
    loaderMountloader: false,
    loaderMount: false,
    animCmpnt: false,
  });
  const [timer, setTimer] = useState(0);
  const [snakQuestion, setSnakQuestion] = useState({
    open: false,
    Transition: Fade,
  });

  useEffect(() => {
    window.onpopstate = (e) => {
      // props.history.go(1);
    };

    setDetails({
      ...details,
      loaderMount: true,
    });

    base_url
      .get(`exam/${props.match.params.coursId}`)
      .then((response) => {
        setState({
          ...state,
          // examIdMain: response.data.questions[0].pivot.exam_id,
          paramsId: response.data.questions.length,
          time: Date.now(),
        });
        setDetails({
          ...details,
          animCmpnt: true,
          loaderMount: false,
        });
        setData(response.data);
        setTimer(response.data.exam_time);
        setMaxCount(response.data.questions[state.animParamsId].right_answers);
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);
  useEffect(() => {
    setTemAnswer(null);
    setState({
      ...state,
      animationItems: true,
    });
    setTimeout(() => {
      setState({
        ...state,
        animationItems: false,
        animParamsId: parseInt(props.match.params.id) - 1,
      });
    }, 300);
  }, [props.match.params.id]);

  const handleChangeValue = (answerId, QuestionId) => {
    const isExist = state.defaultChecked.answer_ids.find(
      (an) => an === answerId
    );
    const rest = state.defaultChecked.answer_ids.filter(
      (an) => an !== answerId
    );
    const answer = {
      answer_ids: state.defaultChecked.answer_ids
        ? state.defaultChecked.answer_ids
        : [],
      question_id: QuestionId,
    };

    if (!isExist && maxCount !== count) {
      answer.answer_ids.push(answerId);
      setCount(count + 1);
    } else if (state.defaultChecked.answer_ids.find((i) => i === answerId)) {
      setCount(count - 1);
      answer.answer_ids = rest;
    }

    if (state.defaultChecked.answer_ids.find((i) => i === answerId))
      setTemAnswer(answer);
    setState({
      ...state,
      defaultChecked: answer,
    });
  };

  const isChecked = (id) => {
    if (state.defaultChecked.answer_ids.find((i) => i === id)) return true;

    return false;
  };

  const nextQuestion = () => {
    if (
      document.getElementById("answerTextField") !== null &&
      document.getElementById("answerTextField")?.value !== null
    ) {
      document.getElementById("answerTextField").value = "";
    }

    if (parseInt(props.match.params.id) !== data?.questions?.length)
      setMaxCount(data?.questions[state.animParamsId + 1]?.right_answers);
    if (temAnswer !== null) {
      let temp = [];
      if (answers.length == 0) {
        temp.push(temAnswer);
      } else {
        answers.map((info) => {
          if (
            info.answer_ids !== temAnswer.answer_ids &&
            info.question_id !== temAnswer.question_id
          ) {
            temp.push(info);
          }
        });
        temp.push(temAnswer);
      }
      setTemAnswer(null);
      let paramsNumber = parseInt(props.match.params.id);
      setCount(0);
      setAnswers(temp);
      setState({
        ...state,
        pervQueId: paramsNumber,
        defaultChecked: { answer_ids: [], question_id: "" },
      });
      if (paramsNumber === data.questions.length) {
        setState({
          ...state,
          popupStatus: true,
        });
      } else {
        props.history.push(
          `/Education/Quiz/${props.match.params.coursId}/${paramsNumber + 1}`
        );
      }
    } else {
      setSnakQuestion({
        ...snakQuestion,
        open: true,
      });
    }
  };

  const prevQuestion = () => {
    setCount(0);
    let paramsNumber = parseInt(props.match.params.id);
    const rest = answers.filter((anw) => anw.question_id !== state.pervQueId);
    setAnswers(rest);
    if (!(paramsNumber == 1)) {
      props.history.push(
        `/Education/Quiz/${props.match.params.coursId}/${paramsNumber - 1}`
      );
    }
  };

  // Renderer callback with condition
  const timerRender = ({ minutes, seconds, completed }) => {
    // if ((minutes == 0) && (seconds == 30)) {
    //     setState({
    //         ...state,
    //         timerAnimation: true,
    //     })
    // }
    if (!state.finished && completed && minutes == 0 && seconds == 0) {
      setState({
        ...state,
        timeOut: true,
        timerAnimation: false,
        finished: true,
      });
      return <span>00:00</span>;
    } else {
      // Render a countdown
      return (
        <span>
          {minutes}:{seconds}
        </span>
      );
    }
  };

  const handleSelectedValue = (value) => {
    if (temAnswer == null) {
      setTemAnswer(value);
    }
  };
  const handleCloseCity = () => {
    setSnakQuestion({
      ...snakQuestion,
      open: false,
    });
  };

  const handleResaultExam = (value) => {
    const data = {
      exam_id: props.match.params.coursId,
      answers: value,
    };

    base_url
      .post(`exam_result`, data)
      .then((response) => {
        localStorage.setItem("QuizResault", JSON.stringify(response.data));
        props.history.push(`/Education/Quiz-result`);
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
          }
        }
      });
  };

  const handleSetResaultexam = () => {
    setState({
      ...state,
      popupStatus: false,
    });
    setDetails({
      ...details,
      loader: true,
    });

    handleResaultExam(answers);
  };

  const timeOutExam = () => {
    setState({
      ...state,
      timeOut: false,
    });
    setDetails({
      ...details,
      loader: true,
    });
    handleResaultExam(answers);
  };

  const handleTextInput = (text, id) => {
    setTemAnswer({
      question_id: id,
      answer_text: text,
    });
  };

  return (
    <div className={`instructpg exam ${details.animCmpnt ? "active" : ""}`}>
      <Header innerPage={true} title={"آزمون"} />

      <Loader active={details.loader} />

      <div className="bk-light">
        <Loader active={details.loaderMount} />
      </div>

      <Snackbar
        open={snakQuestion.open}
        onClose={handleCloseCity}
        TransitionComponent={snakQuestion.Transition}
        message="پاسخ سوال را انتخاب کنید."
        key={snakQuestion.Transition.name}
      />

      <Popup active={state.popupStatus}>
        <h4>اتمام آزمون</h4>
        <span>آیا از اتمام آزمون مطمئن هستید ؟</span>
        <div className="btns-popup">
          <div className="btn-base btn-black btn-sircle">
            <Button variant="contained" onClick={handleSetResaultexam}>
              بله
            </Button>
          </div>
          <div className="btn-base btn-border-black btn-sircle">
            <Button
              variant="contained"
              onClick={() =>
                setState({ ...state, details: false, popupStatus: false })
              }
            >
              بازگشت
            </Button>
          </div>
        </div>
      </Popup>

      <Popup active={state.timeOut}>
        <div className="tim-outexm">
          <i className="icon-clock"></i>
          <h4>زمان آزمون تمام شد</h4>
          <div className="btn-base btn-black btn-sircle">
            <Button variant="contained" onClick={timeOutExam}>
              اتمام آزمون
            </Button>
          </div>
        </div>
      </Popup>

      <Fragment>
        <div className="exams">
          <div className="timer">
            <span>
              {parseInt(props.match.params.id)}
              {" از "}
              {data.length == 0 ? "" : data.questions.length}
            </span>
            <span className={`${state.timerAnimation ? "timer-anim" : ""}`}>
              {timer !== 0 ? (
                <Countdown
                  date={state.time + timer * 1000}
                  renderer={timerRender}
                />
              ) : (
                <span>00:00</span>
              )}
            </span>
          </div>
          <div className="step">
            <LinearProgress
              variant="determinate"
              value={
                data.length
                  ? (100 / data.questions.length) *
                    parseInt(props.match.params.id)
                  : null
              }
            />
          </div>
          <div className={`exam-list ${state.animationItems ? "active" : ""}`}>
            <Answeritem
              temAnswer={temAnswer}
              handleTextInput={handleTextInput}
              question={
                data.length == 0 ? [] : data.questions[state.animParamsId]
              }
              isChecked={isChecked}
              count={count}
              answer={state.answerCount}
              values={answers.length === 0 ? [] : answers}
              selectedValue={(info) => handleSelectedValue(info)}
              changeValue={(answerId, questionId) =>
                handleChangeValue(answerId, questionId)
              }
            />
          </div>
        </div>
        <div className="btn-exam">
          <div className={`btn-base btn-black btn-sircle btn-brdr`}>
            {parseInt(props.match.params.id) == 1 ? null : (
              <Button variant="contained" onClick={() => prevQuestion()}>
                قبلی
              </Button>
            )}
          </div>
          <div className={`btn-base btn-black btn-sircle`}>
            <Button variant="contained" onClick={() => nextQuestion()}>
              {parseInt(props.match.params.id) === data?.questions?.length
                ? "پایان آزمون"
                : "بعدی"}
            </Button>
          </div>
        </div>
      </Fragment>
    </div>
  );
};

export default Exam;
